// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-248dfed2]{align-items:center;border:2px solid #1565c0;border-radius:3px;color:rgba(0,0,0,.87);display:flex;font-size:16px;font-weight:700;height:42px;justify-content:center;letter-spacing:0;margin-right:8px;margin-top:8px;text-align:center;text-decoration:none;transition:0s;width:42px}.link[data-v-248dfed2]:hover{background:#265ef5;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
